import api from "@/api/api-v2-config";

export async function getPerformanceRecordAxios() {    
  return await   api.get("hrms/records?PageNumber=1&PageSize=10000");
}

export async function postPerformanceRecordAxios(performenceRecord) {    
  return await api.post("hrms/records", performenceRecord);
}

export async function putPerformanceRecordAxios(performenceRecord) {    
  return await api.put("hrms/records", performenceRecord);
}
export async function deletePerformanceRecordAxios(id) {    
  return await api.delete("hrms/records?RecordId=" + id);
}